module.exports = __webpack_public_path__ + "img/law_thumbnail-400x300.3b551909.jpg";